































































































































































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Urls } from '@/Urls';
import Decisions from "@/store/modules/Decisions";
import ScoringKeys from "@/store/modules/ScoringKeys";
import FactorGroupScoringDefinition from "@/components/scoring-definition/FactorGroupScoringDefinition.vue";
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import FactorScoringDefinitionCreatorDialog
    from "@/components/scoring-definition/FactorScoringDefinitionCreatorDialog.vue";
import Viewpoints from "@/store/modules/Viewpoints";
import { Factor, FactorResource } from "@/api/model/FactorResource";
import _ from "lodash";

const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const scoringKeysModule = getModule(ScoringKeys);

@Component({
    components: {
        ScoringKeyEditorDialog,
        FactorGroupScoringDefinition,
        DialogFactorScoringDefinitionCreator: FactorScoringDefinitionCreatorDialog,
    }
})
export default class FactorNavigation extends Vue {

    @Prop({default: null, type: String})
    search!: string | null;

    @Model('updated:selectedId')
    selectedId!: string;

    @Prop()
    selectionPath!: string[]

    @Prop()
    tree!: any;

    @Prop()
    navIndex!: number;

    @Prop()
    factorResources!: { [id: string]: FactorResource };

    @Prop({default: false, type: Boolean})
    openAll!: boolean;

    @Prop({default: false, type: Boolean})
    menuVisible!: boolean;

    @Prop({default: false, type: Boolean})
    menuEdit!: boolean;

    @Prop({default: false, type: Boolean})
    menuNew!: boolean;

    @Prop({default: false, type: Boolean})
    menuFolderToggle!: boolean;

    @Prop({default: '', type: String})
    clickUrl!: string;

    @Prop({default: 'Select a Factor', type: String})
    header!: string;

    @Prop({default: false, type: Boolean})
    checkable!: boolean;

    @Prop({default: false, type: Boolean})
    factorNavDisabled!: boolean;

    @Prop({default: () => ([]), type: Array})
    selections!: string[];

    @Ref()
    private factorTree: Vue;

    private readonly URLS = Urls;
    // private search: string | null = null;
    private openValues: any[] = [];
    private openAllToggle: boolean = this.openAll;
    private iconList: any = {
        'NONE': 'mdi-border-none-variant',
        'TEXT': 'mdi-format-text',
        'FILE': 'mdi-file-outline',
        'IMAGE': 'mdi-camera',
        'NUMERICAL': 'mdi-pound',
        'DATE_TIME': 'mdi-calendar-clock',
        'PRICE': 'mdi-currency-usd',
        'PERCENTAGE': 'mdi-percent',
        'CATEGORICAL': 'mdi-tag',
        'BOOLEAN': 'mdi-checkbox-marked',
    };
    private selectedFactors: any = [];
    
    mounted() {
        if (this.openAll) {
            this.openAllGroups();
        }
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    // Get the values to display which one is selected in the tree
    get activeItems(): any[] {
        if (this.selectedId) {
            return [{id: this.selectedId}];
        }
        return [];
    }

    // When this value gets changed we need to update the module so that it reflects the selected value on all views
    set activeItems(treeItems: any[]) {
    }

    get templateTreeArray(): any[] {
        let res: any[] = [{
            id: 'ROOT',
            name: `${this.pluralFactorLabel}`,
            children: [this.tree],
            type: 'VTreeview',
        }];
        return res;
    }

    get isNavTreeOpen(): boolean {
        return this.openValues.some((el: any) => el.id === 'ROOT');
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    @Watch('openValues', {deep: true})
    onOpenValuesChanged(newVal: any, oldVal: any) {
        if (!newVal.some((el: any) => el.id === 'ROOT')) {
            this.openAllToggle = false;
        }
        if (!oldVal.some((el: any) => el.id === 'ROOT') && newVal.some((el: any) => el.id === 'ROOT')) {
            this.openAllToggle = true;
        }
    }


    @Watch('selectedDecision', {deep: true})
    onSelectedDecisionChanged(newVal: any, oldVal: any) {
        if (this.openAll && newVal && Object.keys(newVal).length) {
            this.openAllGroups();
        }
    }

    private openAllGroups() {
        setTimeout(() => this.openTree(), 1000);
    }

    @Emit('selected')
    @Emit('updated:selectedId')
    private selectFactorResource(treeItem: any) {
        if (treeItem.id) {
            this.scrollIntoView(treeItem.id)
            this.activeItems = [treeItem];
            if (this.navIndex != undefined) {
                return { factor: treeItem.id, index: this.navIndex}
            } else {
                return treeItem.id;
            }
        } else {
            return '';
        }
    }

    /*
     If there is a click in the tree in one of the views,
     we will expand the tree so that we can see the value in the navigation tree
     */
    @Watch('selectedId')
    private updateOpenItems() {
        let openValueIds = this.openValues.map((v: any) => v.id);
        if (this.selectionPath) {
            let missingVals = this.selectionPath.filter(id => !openValueIds.includes(id));
            let addingValues = missingVals.map(id => {
                return {id: id}
            })
            this.openValues.splice(0, 0, ...addingValues)
        }
    }

    private scrollIntoView(treeItemId: string) {
        if (document.getElementById(treeItemId) != null) {
            document.getElementById(treeItemId)!.scrollIntoView({behavior: "smooth", block: "center"});
            // TODO - Refactor - Attempt to wait fo the Expansion Panels to open (2020-06-24 - Dion)
        } else {
            setTimeout(() => {
                document.getElementById(treeItemId)!.scrollIntoView({behavior: "smooth", block: "center"});
            }, 2000);
        }
    }

    // If you want to have the FactorTree open in a custom way
    private customOpenValues() {
        this.openValues = [];
        this.buildOpenValues(this.templateTreeArray || []);
    }

    private buildOpenValues(openValue: any[]) {
        if (openValue && openValue.length) {
            openValue.forEach((el: any) => {
                if (this.showMenuItem(el.id)) {
                    this.openValues.push(el);
                    if (el.hasOwnProperty('children') && el.children && el.children.length) {
                        this.buildOpenValues(el.children);
                    }
                }
            });
        }
    }

    private showMenuItem(id: string): boolean {
        return false;
    }

    private openTree() {
        this.openAllToggle = true;
        (this.$refs.factorTree as Vue & { updateAll: (val: boolean) => void }).updateAll(true);
    }

    private closeTree() {
        this.openAllToggle = false;
        (this.$refs.factorTree as Vue & { updateAll: (val: boolean) => void }).updateAll(false);
    }

    private getIcon(id: string) {
        if (!id || !this.factorResources.hasOwnProperty(id)) return;
        let factor = this.factorResources[id] as Factor;
        if (factor.valueTypeDefinition && factor.valueTypeDefinition.valueSubType) {
            return this.iconList[factor.valueTypeDefinition.valueSubType];
        } else if (factor.valueTypeDefinition) {
            return this.iconList[factor.valueTypeDefinition.valueType];
        }
        return this.iconList['NONE']
    }

    @Watch('selectedFactors')
    private onChangeSelectedFactors(newVal: any, oldVal: any) {
            if(!_.isEqual(newVal, oldVal))
                this.$emit('selectedFactors', this.selectedFactors.map((factor: any) => factor.id))
    }

    @Watch('selections')
    private onChangeSelections() {
             this.selectedFactors= this.selections.map((factorId: any) => this.factorResources[factorId]);
    }
}
